export default "__VITE_ASSET__D6IhkX09__"